import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mobileData as data } from '../data';

function CameraIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="mb-icon-left">
      <path d="M4 7h3l2-2h6l2 2h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2zm8 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10z" />
    </svg>
  );
}

function Pill({ children }: { children: React.ReactNode }) {
  return <span className="mb-pill">{children}</span>;
}

export default function PhysiquePage() {
  const p = data.progress_pics;
  return (
    <div className="mb-stack">
      <div className="mb-h1">Physique tracking</div>
      <div className="mb-card">
        <div className="mb-card-title">Photo cadence</div>
        <div className="mb-row-wrap">
          <Pill>Every {p.frequency_weeks} weeks</Pill>
          <Pill>Reminders on Sundays</Pill>
        </div>
      </div>
      {p.poses.map((pose, i) => (
        <div key={pose.view} className="mb-card">
          <div className="mb-row-between mb-mb4">
            <div className="mb-strong">{i + 1}. {pose.view} view</div>
            <CheckCircle2 size={16} className="mb-muted" />
          </div>
          <div className="mb-muted">{pose.cue}</div>
        </div>
      ))}
      <div className="mb-grid2">
        <button className="mb-btn"><CameraIcon /> New photo</button>
        <button className="mb-btn-primary">Compare</button>
      </div>
    </div>
  );
}


